import React from 'react';

const Payment = () => {
    return (
        <div>
            <h2 className='text-white py-5'>Payment System Comming soon ......</h2>
        </div>
    );
};

export default Payment;